import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { BusinessDocumentSearch } from '@/features/business_documents/List/Search/Search';
import { BusinessDocumentTableView } from '@/features/business_documents/List/Table';
import {
  useBusinessDocumentFormInitial,
  useBusinessDocumentSearchQuery,
} from '@/features/business_documents/List/hooks';
import { memo } from 'react';

export const BusinessDocumentTableList = memo(() => {
  const defaultValues = useBusinessDocumentFormInitial();
  const { searchQuery, handleSearch } =
    useBusinessDocumentSearchQuery(defaultValues);

  return (
    <Wrapper isProto={false}>
      <BusinessDocumentSearch
        defaultValues={defaultValues}
        onSearch={handleSearch}
      />
      <BusinessDocumentTableView
        searchQuery={searchQuery}
        onSearch={handleSearch}
      />
    </Wrapper>
  );
});
BusinessDocumentTableList.displayName = 'BusinessDocumentTableList';
